import { Grid, Typography, makeStyles } from '@material-ui/core';
import PaymentMethod from "../PaymentMethod";

const useStyles = makeStyles(() => ({
	title: {
		fontSize: '14px',
		color: '#888BA0',
		fontWeight: 500,
	},
	subTitle: {
		color: '#101740',
		display: 'flex',
		alignItems: 'center',
	},
}));

const RowTitle = ({ title, online }) => {
	const classes = useStyles();
	return (
		<Grid container>
			<Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
				<Typography className={classes.title}>{title}</Typography>
				<Typography className={classes.subTitle} style={{ fontSize: '18px', fontWeight: 700 }}>
					2,625,000
					<Typography
						className={classes.subTitle}
						style={{ fontSize: '12px', fontWeight: 500, marginRight: '4px' }}
					>
						تومان
					</Typography>
				</Typography>
			</Grid>
			{online && (
				<PaymentMethod method="پرداخت آنلاین"/>
			)}
		</Grid>
	);
};

export default RowTitle;
